<div class="row message-container"
     [ngClass]="{ 'error': generalError || sessionExpired || invalidID }">

    <div class="col-12 message"
         align="middle">
        <span *ngIf="alreadyCompleted">{{ 'inSign.already_completed' | translate }}</span>

        <span *ngIf="generalError">{{ 'inSign.general_error' | translate }}</span>
        <span *ngIf="sessionExpired">{{ 'inSign.session_expired' | translate }}</span>
        <span *ngIf="invalidID">{{ 'inSign.invalid_id' | translate }}</span>
    </div>

</div>

